import type { CityConfig } from "../city-template/types";

export const lewistonConfig: CityConfig = {
  city: "Lewiston",
  state: "Idaho",
  stateAbbr: "ID",
  slug: "lewiston",
  route: "/lewiston",
  title: "Lewiston ID Passport — Expedited & Emergency Service | Fast Passport Center",
  metaDescription: "Expedited and emergency passport services in Lewiston, Idaho — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Lewiston, Clarkston, Lewis-Clark State College, and all Lewis-Clark Valley communities.",
  h1: "Expedited Passport Services in Lewiston, ID",
  heroSubtitle: "Lewis-Clark State College study abroad program departing soon? Business trip connecting through Spokane or Boise? Lewis-Clark Valley family heading to Canada for the weekend? Lewiston residents — from LCSC students to Clearwater Paper professionals to Nez Perce County families — trust us for fast, reliable passport processing. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20panoramic%20view%20of%20Lewiston%20Idaho%20with%20the%20Snake%20River%20and%20Clearwater%20River%20confluence%20in%20the%20foreground%2C%20the%20historic%20Lewis-Clark%20Valley%20with%20rolling%20hills%20and%20dramatic%20canyon%20walls%2C%20downtown%20Lewiston%20visible%20along%20the%20riverbank%2C%20golden%20hour%20sunlight%20reflecting%20on%20the%20water%2C%20inland%20seaport%20city%20with%20beautiful%20Pacific%20Northwest%20landscape%20and%20industrial%20riverfront&width=1800&height=700&seq=lewiston-hero-2026&orientation=landscape",
  heroImageAlt: "Lewiston Idaho Snake and Clearwater Rivers confluence at golden hour",
  geoPosition: "46.4168;-117.0174",
  geoPlacename: "Lewiston, Idaho",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "915 2nd Ave Suite 500, Seattle, WA 98101",
    distance: "Closest regional agency — approximately 300 miles via US-195 and I-90, appointments required",
  },
  nearbyCitiesZips: [
    { name: "Lewiston", zips: "83501" },
    { name: "Clarkston", zips: "99403" },
    { name: "Moscow", zips: "83843, 83844" },
    { name: "Orofino", zips: "83544" },
    { name: "Grangeville", zips: "83530" },
    { name: "Pullman", zips: "99163, 99164" },
    { name: "Lapwai", zips: "83540" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Lewis-Clark Valley Emergency Processing", desc: "Reserved courier access — as fast as 24 hours for Lewiston and Nez Perce County travelers with immediate international departures." },
    { icon: "ri-flight-takeoff-line", title: "LWS & GEG Airport Expertise", desc: "Lewiston-Nez Perce County Airport is minutes away with connections to Salt Lake City and Seattle. Spokane International Airport is 2 hours north with broader options. We know both." },
    { icon: "ri-graduation-cap-line", title: "LCSC Student & Faculty Focus", desc: "Lewis-Clark State College students studying abroad and faculty attending international conferences — we understand the academic calendar and expedited timeline needs." },
    { icon: "ri-home-heart-line", title: "Lewis-Clark Valley Family Specialists", desc: "From first-time passports for Clarkston families to renewals for Orofino professionals — we make the process clear, fast, and stress-free for the entire valley." },
  ],
  internalLinks: [
    { name: "Fast passport services in Moscow, ID", route: "/moscow" },
    { name: "Expedited services in Coeur d'Alene, ID", route: "/coeur-dalene" },
    { name: "Idaho passport services overview", route: "/idaho" },
  ],
  fpcOfficeAddress: "915 2nd Ave Suite 500, Seattle, WA 98101",
  fpcOfficeNote: "Fast Passport Center serves Lewiston via secure registered courier with direct access to the Seattle Passport Agency. Our registered couriers hand-deliver your documents — meaning Lewiston residents get faster results without driving 300 miles to Seattle. Ship from any UPS Store, FedEx Office, or post office in Nez Perce County.",
  fpcOfficeDistance: "Serving Lewiston, Clarkston, Moscow, Orofino, Grangeville, Pullman, Lapwai, and all Lewis-Clark Valley communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Lewiston and the greater Lewis-Clark Valley. From the historic downtown riverfront to the Lewis-Clark State College campus, from the Port of Lewiston industrial area to the Clarkston retail corridor — we serve the entire bi-state valley community. Our courier service eliminates the need to drive to Seattle for passport agency appointments.",
  nearbyCitiesIntro: "We serve Lewiston and all Lewis-Clark Valley communities including Clarkston (WA), Moscow, Orofino, Grangeville, Pullman, and Lapwai. We also serve travelers departing from Lewiston-Nez Perce County Airport (LWS), Pullman-Moscow Regional Airport (PUW), and Spokane International Airport (GEG).",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Lewiston as simple as possible. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Lewiston travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "Lewis-Clark Valley travelers encounter unique passport issues — from LCSC study abroad deadlines to Canada border crossing confusion for river communities. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Lewiston and Lewis-Clark Valley travelers — from LCSC students to Clarkston families to Orofino professionals — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Lewiston, ID? Here are the most common ones we hear from Lewis-Clark Valley travelers.",
  statePageRoute: "/states/idaho",
  statePageName: "Idaho",
  servicesIntro: "Whether you need a renewal before a Spokane international connection, an emergency passport for a last-minute business trip, or a first-time passport for your LCSC student heading abroad — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://itd.idaho.gov/dmv/",
  dmvLabel: "Idaho Transportation Department — DMV Services",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Closest agency is Seattle (300 miles)", "Not practical for most Lewis-Clark Valley travelers"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned", "Daily status updates", "No need to drive to Seattle"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned", "Daily status updates"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent", "Updates only by physical mail", "Cannot upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "International flight from Spokane in 48 hours? Family emergency requiring immediate travel? Our emergency courier service submits via reserved agency slots — as fast as 24 hours for Lewiston travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Lewiston residents renew fast — no agency visit required. Perfect for Clearwater Paper professionals and valley families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide LCSC students and valley residents through every step with clear instructions.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: "Student Essential",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions for Lewis-Clark Valley families.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Perfect for frequent Canada travelers from the Lewis-Clark Valley.",
      bullets: ["Wallet-size convenience", "Land and sea travel", "Same expedited processing"],
      badge: "Canada Ready",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Lewiston ID", description: "Urgent passport processing for Lewiston Idaho travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Lewiston ID", description: "Fast passport renewal for Lewiston Idaho residents with a previously-issued passport." },
    { name: "First-Time Passport Lewiston ID", description: "New passport application services for Lewiston Idaho residents and LCSC students." },
    { name: "Child Passport Lewiston ID", description: "Minor passport services for Lewiston Idaho families with children under 16." },
    { name: "Name Change Passport Lewiston ID", description: "Passport name correction after marriage or legal name changes for Lewiston residents." },
    { name: "Passport Card Lewiston ID", description: "Passport card services for land and sea crossings including Canada travel from Lewiston Idaho." },
  ],
  testimonials: [
    {
      name: "Mike D.",
      location: "Lewiston",
      rating: 5,
      text: "Needed a passport renewal fast for a business trip to Vancouver. Fast Passport Center processed it in 4 business days. The document review was flawless and the whole process took less than 10 minutes online.",
      service: "Passport Renewal",
    },
    {
      name: "The Harris Family",
      location: "Clarkston, WA",
      rating: 5,
      text: "Booked a trip to Mexico for spring break and realized the whole family needed new passports. Fast Passport Center handled all four applications and we had them in 7 days. Saved our vacation.",
      service: "Family Passports",
    },
    {
      name: "Samantha B.",
      location: "Lewiston — LCSC Student",
      rating: 5,
      text: "Accepted to a nursing study abroad program in Costa Rica with only 5 weeks before departure. Never had a passport. They walked me through everything and I had my passport in 6 days.",
      service: "New Passport",
    },
    {
      name: "Jim R.",
      location: "Orofino",
      rating: 5,
      text: "Retired and planning a fishing trip to Canada. Needed a passport card fast. Fast Passport Center got it processed in 5 days and I was on the Clearwater's Canadian tributaries a week later.",
      service: "Passport Card",
    },
  ],
  facilities: [
    {
      id: "lewiston-1",
      name: "Lewiston Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1613 Idaho St",
      city: "Lewiston",
      state: "ID",
      zip: "83501",
      phone: "(208) 746-3666",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Lewiston",
      website: "https://tools.usps.com/find-location.htm?location=1377545",
      websiteLabel: "USPS Location",
      notes: "Primary passport acceptance facility in Lewiston. Passport photos available. Appointment recommended — call ahead during peak travel seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "lewiston-2",
      name: "Nez Perce County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "1230 Main St",
      city: "Lewiston",
      state: "ID",
      zip: "83501",
      phone: "(208) 799-3020",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Downtown Lewiston",
      website: "https://www.co.nezperce.id.us/elected-officials/clerk/",
      websiteLabel: "Nez Perce County Clerk",
      notes: "County clerk passport acceptance services at the Nez Perce County Courthouse. Serves all county residents. No photo services on-site — bring your own photos.",
      icon: "ri-government-line",
    },
    {
      id: "lewiston-3",
      name: "Moscow Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "220 E 5th St",
      city: "Moscow",
      state: "ID",
      zip: "83843",
      phone: "(208) 882-2301",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Moscow — 30 miles north",
      website: "https://tools.usps.com/find-location.htm?location=1377548",
      websiteLabel: "USPS Location",
      notes: "Serves Moscow and northern Latah County. Good backup option for Lewiston residents if local appointments are full. Passport photos available.",
      icon: "ri-mail-line",
    },
    {
      id: "lewiston-4",
      name: "Clarkston Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "949 6th St",
      city: "Clarkston",
      state: "WA",
      zip: "99403",
      phone: "(509) 758-4672",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Clarkston — just across the Snake River bridge",
      website: "https://tools.usps.com/find-location.htm?location=1377504",
      websiteLabel: "USPS Location",
      notes: "Serves Clarkston, WA and Asotin County. Convenient for Washington residents in the Lewis-Clark Valley. Passport photos available. Washington state services.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Seattle agency is 300 miles away", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 300 miles to Seattle or fly there", fpc: "Most Lewiston travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel with proof of departure", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Lewis-Clark Valley Expertise", agency: "Generic — no LWS/GEG airport or LCSC knowledge", fpc: "Full Lewis-Clark Valley, river port, and bi-state expertise built in" },
  ],
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "LCSC Study Abroad Timeline Rush",
      description: "Lewis-Clark State College students accepted to study abroad programs often get just 6–8 weeks before departure. Many students — especially from rural areas — have never had passports and underestimate the application process time.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Cross-Border Confusion with Clarkston, WA",
      description: "The Lewiston-Clarkston metro area spans two states with different DMV and vital records systems. Residents sometimes try to use Washington documents for Idaho passport applications or vice versa — we navigate both state systems for you.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Issues from Valley Retailers",
      description: "Lewis-Clark Valley pharmacies produce photos that frequently fail State Department standards — wrong background, shadows, head positioning issues. We catch these in review before they cause rejection and delay.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Valley families frequently overlook the DS-3053 consent form when one parent is unavailable. This is an automatic rejection — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Assuming River Industry Travel Does Not Need Documentation",
      description: "The Port of Lewiston is Idaho's only seaport, and industry professionals traveling internationally for shipping logistics often assume business travel does not require a U.S. passport. It does — and many discover this days before departure.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or LCSC dorm." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Lewiston clients ship from the UPS Store on 21st St or the Lewiston Post Office." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 300 miles to Seattle." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Lewiston?", a: "We offer Lewiston-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Is there a passport office in Lewiston?", a: "The Lewiston Post Office at 1613 Idaho St serves as a passport acceptance facility for first-time applications. The Nez Perce County Clerk at 1230 Main St also provides acceptance services. For expedited processing, our registered courier service is the fastest option." },
    { q: "Can LCSC students apply for passports on campus?", a: "Lewis-Clark State College does not have an on-campus passport acceptance facility. LCSC students should use the Lewiston Post Office (walkable from campus) or the Nez Perce County Clerk for their acceptance visit. We provide step-by-step guidance for LCSC students." },
    { q: "Do you serve Clarkston, WA residents too?", a: "Yes. We serve the entire bi-state Lewis-Clark Valley including Clarkston, Washington. Clarkston residents can use the Clarkston Post Office for acceptance services and then ship documents to us. The process works the same regardless of which state you live in." },
    { q: "Where is the closest passport agency to Lewiston?", a: "The Seattle Passport Agency is approximately 300 miles away. It requires appointments and serves life-or-death emergencies only. For all other expedited needs, our courier channel is faster and eliminates the drive." },
    { q: "Can you help with flights from Lewiston Airport?", a: "Yes. Lewiston-Nez Perce County Airport (LWS) is just minutes from downtown with Delta Connection flights to Salt Lake City and Seattle — both major international gateways. Spokane International Airport (GEG) is 2 hours north with broader options." },
    { q: "What documents do Lewiston applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. For Clarkston/WA residents, we provide Washington-specific guidance for vital records. We provide a Lewiston-specific checklist." },
    { q: "Where can I get passport photos in Lewiston?", a: "The Lewiston Post Office, Walgreens on 21st St, and Staples all offer passport photo services. We recommend confirming photo standards compliance before visiting — quality varies significantly in the valley." },
    { q: "What is the best price for expedited service in Lewiston?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers." },
    { q: "How do I check my Lewiston passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Lewiston to final return shipping typically matches your chosen speed tier." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Lewiston Residents",
    intro: "Lewiston is a unique river city — Idaho's only inland seaport — serving as the commercial hub for north central Idaho and southeastern Washington. Here's what Lewis-Clark Valley travelers need to know about passport timing.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "LWS — Lewiston-Nez Perce County Airport",
        subtitle: "Regional airport just minutes from downtown Lewiston",
        description: "Lewiston-Nez Perce County Airport offers daily Delta Connection flights to Salt Lake City (SLC) and Seattle (SEA), connecting the Lewis-Clark Valley to the world. The airport is literally 5 minutes from downtown, making international travel surprisingly accessible for a city of Lewiston's size. Spokane International Airport (GEG) is 2 hours north for broader options including Alaska, Southwest, and United flights.",
        tip: "LWS-to-SLC connections are the most common international gateway. Your passport must be valid at LWS check-in for international connections, not just at SLC or SEA.",
      },
      {
        icon: "ri-ship-line",
        title: "Port of Lewiston & River Industry Travel",
        subtitle: "Idaho's only seaport — connecting the inland Northwest to the Pacific Ocean",
        description: "The Port of Lewiston is a unique economic asset — a deep-water inland seaport connected to the Pacific Ocean via the Snake and Columbia River lock system. Port-related businesses, shipping logistics professionals, and agricultural exporters regularly travel internationally for trade negotiations, shipping conferences, and supply chain management. These trips often come with 2–3 weeks of notice.",
        tip: "River and port industry professionals should maintain a current passport at all times. International shipping meetings and trade negotiations in Asia, Europe, and South America come with short notice windows.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "LCSC — Lewis-Clark State College",
        subtitle: "Nursing, education, and technical programs with international opportunities",
        description: "LCSC sends students abroad each year through nursing clinical rotations, education student teaching programs, and technical exchange programs. The college's nursing program — one of the best in the region — operates international clinical experiences in Central America and the Caribbean. Students accepted to these programs typically have 6–8 weeks before departure.",
        tip: "LCSC nursing and education students should begin their passport process when applying to international programs, not after acceptance. The acceptance-to-departure window is often too tight for first-time applicants starting from scratch.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Lewiston & the Bi-State Lewis-Clark Valley",
      description: "Lewiston and Clarkston together form one of the most integrated bi-state communities in the Pacific Northwest. This means our clients include both Idaho and Washington residents, each with different DMV, vital records, and documentation systems. We navigate both seamlessly.",
    },
  },
  destinations: {
    title: "Where Lewiston Travelers Go — And Why Passports Get Urgent",
    intro: "The Lewis-Clark Valley generates international travel from its unique mix of river commerce, higher education, and proximity to Canada.",
    stats: [
      { stat: "35%", label: "of Lewiston expedited requests are business-related — port industry, Clearwater Paper, shipping logistics" },
      { stat: "5–8 Weeks", label: "average lead time from LCSC program acceptance to international departure" },
      { stat: "May–Aug", label: "peak season when river shipping conferences, summer family travel, and Canada trips converge" },
      { stat: "5 Days", label: "typical turnaround for Lewiston-area expedited passport processing" },
    ],
    destinations: [
      { name: "Canada", context: "British Columbia business and leisure — Vancouver, Okanagan, Canadian Rockies", urgency: "Summer road trips booked 2–4 weeks out, families discover expired documents at border", icon: "ri-map-pin-2-line" },
      { name: "Asia", context: "River shipping and port industry trade missions to Japan, South Korea, China", urgency: "Trade missions and shipping conferences with 2–3 weeks of notice", icon: "ri-map-pin-2-line" },
      { name: "Europe", context: "LCSC faculty conferences, Clearwater Paper industry events, valley family summer vacations", urgency: "Conference dates fixed, families book 6–8 weeks out for summer trips", icon: "ri-map-pin-2-line" },
      { name: "Central America & Caribbean", context: "LCSC nursing clinical rotations, valley family spring break and winter getaways", urgency: "Clinical rotation dates fixed, spring break bookings peak January–February", icon: "ri-map-pin-2-line" },
      { name: "South America", context: "Agricultural export industry meetings in Brazil, Argentina, Chile", urgency: "Trade negotiations with 1–3 weeks of notice and complex visa requirements", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other North Central Idaho Service Areas",
    crossLinksDesc: "We serve travelers across north central Idaho and the Palouse with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Moscow", route: "/moscow" },
      { name: "Coeur d'Alene", route: "/coeur-dalene" },
    ],
  },
  photoLocations: [
    { name: "Lewiston Post Office", address: "1613 Idaho St, Lewiston, ID 83501", hours: "Mon–Fri 9 AM – 4 PM" },
    { name: "Walgreens — Lewiston", address: "2102 19th Ave, Lewiston, ID 83501", hours: "Daily 7 AM – 11 PM" },
    { name: "Staples — Lewiston", address: "2340 Nez Perce Dr, Lewiston, ID 83501", hours: "Mon–Fri 8 AM – 8 PM, Sat 9 AM – 6 PM" },
    { name: "The UPS Store — Lewiston", address: "2128 12th Ave, Lewiston, ID 83501", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Nez Perce County DMV — Lewiston",
      address: "1230 Main St, Lewiston, ID 83501",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "Asotin County DMV — Clarkston (WA residents)",
      address: "135 2nd St, Clarkston, WA 99403",
      hours: "Mon–Fri 8:00 AM – 4:30 PM",
      note: "For Clarkston and Asotin County, WA residents. REAL ID available. Different state requirements — we guide you through both.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "LWS",
      name: "Lewiston-Nez Perce County Airport",
      distance: "About 5 minutes from downtown Lewiston",
      address: "3632 Stearman St, Lewiston, ID 83501",
      note: "Regional airport with daily Delta Connection flights to Salt Lake City (SLC) and Seattle (SEA). Primary gateway for Lewis-Clark Valley international connections.",
      flightUrl: "https://www.cityoflewiston.org/311/Airport",
      flightLabel: "LWS Airport Website",
      featured: true,
    },
    {
      code: "GEG",
      name: "Spokane International Airport",
      distance: "About 2 hours from Lewiston",
      address: "9000 W Airport Dr, Spokane, WA 99224",
      note: "Larger airport with connections to Seattle, Denver, Salt Lake City, Phoenix, Minneapolis, and more. Broader international gateway options.",
      flightUrl: "https://www.spokaneairports.net/",
      flightLabel: "GEG Airport Website",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate (ID)",
      desc: "Request certified birth certificates from Idaho Vital Records. Online, mail, or in-person options available for Nez Perce County.",
      url: "https://healthandwelfare.idaho.gov/services-programs/birth-death-marriage-divorce",
    },
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate (WA)",
      desc: "For Clarkston/Asotin County residents — request certified birth certificates from Washington State Department of Health.",
      url: "https://doh.wa.gov/licenses-permits-and-certificates/vital-records",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate (ID)",
      desc: "Request marriage license records from the Nez Perce County Clerk. Certified copies available for name changes and legal purposes.",
      url: "https://www.co.nezperce.id.us/elected-officials/clerk/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree (ID)",
      desc: "Obtain certified divorce records through the Nez Perce County District Court. Required for name change passport corrections.",
      url: "https://www.co.nezperce.id.us/courts/",
    },
  ],
};